import { render, staticRenderFns } from "./AddSQL.vue?vue&type=template&id=55290ff1&scoped=true&"
import script from "./AddSQL.vue?vue&type=script&lang=js&"
export * from "./AddSQL.vue?vue&type=script&lang=js&"
import style0 from "./AddSQL.vue?vue&type=style&index=0&id=55290ff1&prod&scoped=true&lang=css&"
import style1 from "./AddSQL.vue?vue&type=style&index=1&id=55290ff1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55290ff1",
  null
  
)

export default component.exports